import React, { useState } from "react";
import { withTranslation, useTranslation } from "react-i18next";
import moment from "moment";
import ProcessImage from "react-imgpro";
import TM6 from "./../../../assets/precheckin/tm6.webp";
import PassportImg from "./../../../assets/precheckin/passport.webp";
import FloatInput from "../FloatInput";
import SignatureSelector from "../../../components/SignatureSelector";
import DateTimePickerComponent from "../components/DateTimePickerComponent";

const ThirdStep = (props) => {
  const { t } = useTranslation();
  const [canvas, setCanvas] = useState();
  const [uploadImage, setUploadImage] = useState(props.getDocument);
  const [loadingImage, setLoadingImage] = useState(false);
  const [loadedImage, setLoadedImage] = useState(false);
  const handleOK = (value) => {
    if (value) {
      const returnObj = { name: "signature", value: value };
      props.handleChange({ target: returnObj });
    }
  };

  const handleDocument = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setLoadingImage(true);
      const file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        const returnObj = {
          name: "document",
          value: {
            uri: e.target.result,
            name: file.name,
            type: file.type,
          },
        };
        setUploadImage(returnObj.value);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleDocumentProcessing = (src, err) => {
    if (err) {
      alert(err);
      setUploadImage(null);
    } else {
      let mimeType = src.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
      const returnObj = {
        name: "document",
        value: {
          uri: src,
          name: moment().unix().toString(),
          type: mimeType,
        },
      };
      props.handleChange({ target: returnObj });
    }
    setLoadingImage(false);
    setLoadedImage(true);
  };

  return (
    <div className="flex flex-col justify-center pt-5">
      <div className="mb-8">
        <p className="type-regular medium">{props.title}</p>
      </div>
      {props.globalError && (
        <div className="mb-8">
          <p className="text-14 text-red-500 pt-6">{props.globalError}</p>
        </div>
      )}
      {props.enablePassport && (
        <div className="flex flex-col mb-14 mt-6">
          <FloatInput
            id="passport"
            name="passport"
            label={t("PASSPORT_ID").toUpperCase()}
            span={`*${t("REQUIRED")}`}
            classNameLabel="mb-6 type-title small"
            classNameSpan="text-gray-400 type-regular small pl-2"
            classNameInput="capitalize border-b w-full px-4 rounded-none outline-none focus:outline-none type-normal large md:mb-10"
            onChange={props.handleChange}
            value={props.getPassport}
            labelColor={props.backgroundColorTopBar}
            borderColor={props.backgroundColorTopBar}
          />
          {props.errors && props.errors["passport"] && (
            <p className="text-14 text-red-500 pt-4">
              {props.errors["passport"].join(". ")}
            </p>
          )}
        </div>
      )}

      {!props.enableStripe && (
        <>
          {props.enablePassportExpiration && (
            <div className="flex flex-col mb-12">
              <p
                className="capitalize type-title small mb-6"
                style={{ color: props.backgroundColorTopBar }}>
                {t("DATE_OF_EXPIRY", "DATE OF EXPIRY").toUpperCase()}

                <span className="text-gray-400 type-regular small pl-2">
                  {`*${t("REQUIRED")}`}
                </span>
              </p>
              <DateTimePickerComponent
                modalTitle={t("DATE_OF_EXPIRY", "DATE OF EXPIRY")}
                getDate={props.getDateOfExpiry}
                dateName="dateOfExpiry"
                format={"DD / MM / YYYY"}
                fromYear={moment().year()}
                toYear={moment().add(10, "years").year()}
                primaryColor={props.backgroundColorTopBar}
                borderColor={props.backgroundColorTopBar}
                appHomeTextCallToAction={props.appHomeTextCallToAction}
                buttonStyleName={props.buttonStyleName}
                handleChange={props.handleChange}
                className="type-normal large"
              />
              {props.errors && props.errors["dateOfExpiry"] && (
                <p className="text-14 text-red-500 pt-4">
                  {props.errors["dateOfExpiry"].join(". ")}
                </p>
              )}
            </div>
          )}

          {props.enableTM6 && (
            <div className="flex flex-col mb-14">
              <div className="flex space-x-6 md:mb-10">
                <div className="flex-1 flex flex-col">
                  <FloatInput
                    id="tmSix"
                    name="tmSix"
                    label={t("ARRIVAL_CARD_NUMBER")}
                    classNameLabel="mb-6 type-title small"
                    classNameSpan="text-gray-400 type-regular small pl-2"
                    classNameInput="capitalize border-b w-full px-4 rounded-none outline-none focus:outline-none type-normal large md:mb-10"
                    onChange={props.handleChange}
                    value={props.getTmSix}
                    labelColor={props.backgroundColorTopBar}
                  />
                </div>
                <div>
                  <img
                    src={TM6}
                    className="w-32"
                    alt="TM6"
                  />
                </div>
              </div>
              {props.errors && props.errors["tmSix"] && (
                <p className="text-14 text-red-500 pt-4">
                  {props.errors["tmSix"].join(". ")}
                </p>
              )}
            </div>
          )}

          {props.enablePassport && (
            <div className="flex flex-col">
              <p className="type-regular medium text-okkami-husk mb-6 bg-okkami-mercury px-4 py-6 text-okkami-dove-gray">
                {t("UPLOAD_DOCUMENTS").toUpperCase()}
                <span className="text-gray-400 type-regular small pl-2">
                  {`*${t("REQUIRED")}`}
                </span>
              </p>
              <p className="type-title small text-okkami-dove-gray2 mb-8 text-center">
                {t("UPLOAD_PASSPORT")}
              </p>
              {!uploadImage && (
                <img
                  src={PassportImg}
                  className="mx-auto w-40 mb-8"
                  alt={t("PASSWORD")}
                />
              )}
              {uploadImage && (
                <>
                  <div style={{ display: "none" }}>
                    <ProcessImage
                      image={uploadImage.uri}
                      resize={{ width: 800 }}
                      flip={{ horizontal: false, vertical: false }}
                      quality={75}
                      processedImage={(src, err) =>
                        handleDocumentProcessing(src, err)
                      }
                      className="mx-auto w-48 mb-8 rounded-2xl"
                      alt={t("PASSPORT")}
                    />
                  </div>
                  <img
                    src={uploadImage.uri}
                    className="mx-auto w-52 h-52 md:w-80 md:h-80 object-cover mb-8 rounded-2xl"
                    alt={t("PASSPORT")}
                  />
                </>
              )}

              <label className="w-full flex">
                <input
                  type="file"
                  name="document"
                  accept="image/*"
                  onChange={handleDocument}
                  className="border-b hidden w-full px-4 outline-none focus:outline-none type-normal large md:mb-10"
                />
                <p
                  className={`app-outline-button type-title medium max-w-md w-full mx-auto mb-8 text-center type-title medium cursor-pointer ${props.buttonStyleName}`}
                  style={{
                    backgroundColor: props.backgroundColorTopBar,
                    color: props.appHomeTextCallToAction,
                  }}>
                  {(!loadingImage &&
                    ((!loadedImage && t("UPLOAD")) ||
                      (loadedImage && t("EDIT")))) ||
                    t("LOADING", "Loading...")}
                </p>
              </label>
              {props.errors && props.errors["document"] && (
                <p className="text-14 text-red-500 mb-4">
                  {props.errors["document"].join(". ")}
                </p>
              )}
            </div>
          )}
        </>
      )}

      {props.enableSignature && (
        <div className="flex flex-col mb-14">
          <p className="type-regular medium text-okkami-husk mb-6 bg-okkami-mercury px-4 py-6 text-okkami-dove-gray">
            {t("SIGNATURE").toUpperCase()}
            <span className="text-gray-400 type-regular small pl-2">
              {props.requiredSignature && `*${t("REQUIRED")}`}
            </span>
          </p>
          <SignatureSelector
            color={props.backgroundColorTopBar}
            borderColor={props.backgroundColorTopBar}
            setSignature={handleOK}
            getSignature={props.getSignature}
            setRef={(c) => setCanvas(c)}
            getRef={canvas}
          />
          {props.requiredSignature &&
            props.errors &&
            props.errors["signature"] && (
              <p className="text-14 text-red-500 my-4">
                {props.errors["signature"].join(". ")}
              </p>
            )}
        </div>
      )}
    </div>
  );
};

export default withTranslation()(ThirdStep);
